(function () {
function $c744ae70bee5ad11$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $91a3621b345e90ad$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c744ae70bee5ad11$export$71511d61b312f219)(arr);
}


function $4024e65b134f9b1e$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $9b3436e5f892c3d0$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $2b289bc0d86da12e$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c744ae70bee5ad11$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c744ae70bee5ad11$export$71511d61b312f219)(o, minLen);
}


function $d4a0dad38a9d7fbe$export$71511d61b312f219(arr) {
    return (0, $91a3621b345e90ad$export$71511d61b312f219)(arr) || (0, $4024e65b134f9b1e$export$71511d61b312f219)(arr) || (0, $2b289bc0d86da12e$export$71511d61b312f219)(arr) || (0, $9b3436e5f892c3d0$export$71511d61b312f219)();
}


jQuery(document).on("nfFormReady", function() {
    // For each form field, add a callback so we know when the field was interacted with and has a value.
    var ninjaFormFields = (0, $d4a0dad38a9d7fbe$export$71511d61b312f219)(document.querySelectorAll(".ninja-forms-field:not([type=button]):not([type=submit])"));
    ninjaFormFields.forEach(function(field) {
        field.addEventListener("blur", $97b1bef2f8f6d277$var$nightwingNinjaFormFieldOnBlur);
    });
    var sel = document.querySelector("#nf-field-15");
    if (!sel || sel.tagName !== "SELECT" || sel.DOCUMENT_POSITION_DISCONNECTED.length === 0) return;
    var first = sel.options[0];
    first.disabled = true;
});
// Add the 'is-filled' class to the blurred field's wrap element, so we know when the field was interacted with and has a value. This helps know when to move the floating field labels via CSS.
function $97b1bef2f8f6d277$var$nightwingNinjaFormFieldOnBlur(e) {
    var wrap = e.target.closest(".field-wrap");
    if (wrap && "" !== e.target.value) wrap.classList.add("is-filled");
}

})();
//# sourceMappingURL=index.js.map
